import React from "react";
import { Card, Box, CardContent, Typography, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
const StatCard = ({ icon, title, count, percentage, backgroundColor, onHide }) => (
  <Card
    sx={{
      borderRadius: "14px",
      boxShadow: "0 4px 12px rgba(0,0,0,0.12)",
      px: 1.5,
      pt: 1.2,
      pb: 1,
      height: 72, // ✅ increased from 58 → 72
      position: "relative",
      overflow: "hidden",
      backgroundColor: "rgba(255,255,255,0.96)",
      transition: "all 0.2s ease",
      "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "0 8px 18px rgba(0,0,0,0.18)",
      },
    }}
  >
    {/* Close Button */}
    {onHide && (
      <IconButton
        size="small"
        onClick={onHide}
        sx={{
          position: "absolute",
          top: 4,
          right: 4,
          color: "#9aa4b2",
          "&:hover": { color: "#e53935" },
        }}
      >
        <CloseIcon sx={{ fontSize: 14 }} />
      </IconButton>
    )}

    {/* Icon */}
    <Box
      sx={{
        position: "absolute",
        top: 16, // slightly lower
        left: 14,
        width: 40, // bigger icon box
        height: 40,
        borderRadius: "12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: `${backgroundColor}18`,
        backdropFilter: "blur(8px)",
        border: `1px solid ${backgroundColor}35`,
        color: backgroundColor,
        boxShadow: "0 4px 10px rgba(0,0,0,0.06)",
      }}
    >
      {icon}
    </Box>

    {/* Content */}
    <CardContent
      sx={{
        marginLeft: 6, // slightly more spacing
        pt: 1,
        pb: "6px !important",
      }}
    >
      <Typography
        sx={{
          color: "#6b778c",
          fontWeight: 600,
          textTransform: "uppercase",
          fontSize: 10, // slightly bigger
          lineHeight: 1.1,
        }}
      >
        {title}
      </Typography>

      <Typography
        sx={{
          fontWeight: 700,
          fontSize: 17, // bigger number
          mt: 0.3,
          color: "#1f2d3d",
        }}
      >
        {count}
      </Typography>

      {percentage !== undefined && (
        <Typography
          sx={{
            fontSize: 11,
            fontWeight: 500,
            color: percentage >= 0 ? "#26a69a" : "#e53935", // updated green → teal
          }}
        >
          {percentage >= 0
            ? `+${percentage.toFixed(1)}%`
            : `${percentage.toFixed(1)}%`}
        </Typography>
      )}
    </CardContent>
  </Card>
);
export default StatCard;